import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogFooter, Icon, mergeStyleSets, PrimaryButton, Stack, Text } from '@fluentui/react';
import { getReviewCommentsModalDialogProps } from '@shared/utils/reviewsUtils';
import { SharedColors } from '@fluentui/theme';
const ReviewMarkAsHelpfulModalStyles = mergeStyleSets({
    infoIcon: {
        color: SharedColors.red20,
        fontSize: '16px'
    },
    loader: {
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2200
    }
});
export function ReviewMarkAsHelpfulModalErrorDialog({ context, dismissModal, payload }) {
    const { modalProps, dialogContentProps, maxWidth } = getReviewCommentsModalDialogProps(context.loc('ReviewMarkAsHelpfulModal_UpdateError_Title', 'Something went wrong'));
    return /*#__PURE__*/ _jsxs(Dialog, {
        hidden: !payload.showModal,
        onDismiss: dismissModal,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                role: "dialog",
                horizontal: true,
                tokens: {
                    childrenGap: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        className: ReviewMarkAsHelpfulModalStyles.infoIcon
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: context.loc('ReviewMarkAsHelpfulModal_UpdateError_Description', 'There was a problem marking the review as helpful. Please try again.')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DialogFooter, {
                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                    onClick: dismissModal,
                    text: context.loc('ReviewMarkAsHelpfulModal_UpdateError_Close_Button_Label', 'Close')
                })
            })
        ]
    });
}
